import { Modal, Button as Btn } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import { useTranslation } from "contexts/TranslationContext";
import NoAppFound from "assets/svg/NoAppFound.png";

// Shown instead of the application picker when the user has no SIGNED V2
// applications — nothing to view installments for yet.
const NoApplicationModal = ({ open, onClose }) => {
  const { translate } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable
      closeIcon={<CloseOutlined style={{ fontSize: "16px", color: "#000" }} />}
      centered
      width={560}
      destroyOnClose
    >
      <div className="flex flex-col items-center text-center px-4 py-4">
        <img src={NoAppFound} alt="" className="w-52 md:w-64 mb-6" />
        <h2 className="text-2xl md:text-3xl font-bold text-[#1F1F1F] mb-3">
          {translate("SETTINGS.NO_APPLICATION_FOUND_TITLE")}
        </h2>
        <p className="text-[#8E9196] text-sm md:text-base max-w-md mb-8">
          {translate("SETTINGS.NO_APPLICATION_FOUND_DESC")}
        </p>
        <Btn
          className="rounded-full bg-primary text-white font-semibold px-12 py-5 border border-primary hover:!border-primary hover:border-solid hover:!text-primary"
          onClick={onClose}
        >
          {translate("OTHER_SERVICES.CONTINUE")}
        </Btn>
      </div>
    </Modal>
  );
};

export default NoApplicationModal;
